import { YourAPPProductType } from "../app/core/shared/contentTypes";

/** browser webshop producttype environment used to extend base_environment by compiling product webshop */
export const base_producttype_environment = {
  producttype: YourAPPProductType.webshop
};
